import React from 'react';
import PurchaseRequestDashboard from '../../components/PurchaseRequest/PurchaseRequestDashboard';

const PurchaseRequestDashboardPage = () => {
  return <PurchaseRequestDashboard />;
};

export default PurchaseRequestDashboardPage;